module.exports = __webpack_public_path__ + "img/8.2.TN.64e46d70.png";